var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "needsValidation page-container" }, [
    _c("div", { staticClass: "page-title" }, [
      _vm._v(" " + _vm._s(_vm.$t("menu.batch_payment_details")) + " "),
    ]),
    _c("div", { staticClass: "filter-container" }, [
      _c("div", { staticClass: "custom-breadcrumbs" }, [
        _c("i", {
          staticClass: "el-icon-arrow-left icon-back",
          on: { click: _vm.onClickBackBtn },
        }),
        _c("span", { on: { click: _vm.onClickBackBtn } }, [
          _vm._v(_vm._s(_vm.$t("customerService.payment_details"))),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "tableContainer" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            staticClass: "tableContainer",
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              stripe: "",
              fit: "",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("customerService.transaction_id"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [_vm._v(_vm._s(scope.row.transaction_id))]),
                    ]
                  },
                },
              ]),
            }),
            ["TH", "RU"].includes(_vm.$store.getters.curCountry.country_code)
              ? _c("el-table-column", {
                  attrs: {
                    "min-width": "100",
                    label: _vm.$t("merchantAccount.beneficiary_account_type"),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.beneficiaryAccountTypeFormat(
                                    scope.row.beneficiary_account_type
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    217594820
                  ),
                })
              : _vm._e(),
            ["TH", "RU"].includes(_vm.$store.getters.curCountry.country_code)
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("merchantAccount.beneficiary_type"),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.beneficiaryTypeFormat(
                                    scope.row.beneficiary_type
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1364604891
                  ),
                })
              : _vm._e(),
            _vm.$store.getters.curCountry.country_code === "RU"
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("merchantAccount.beneficiary_category"),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.beneficiaryCategoryFormat(
                                    scope.row.beneficiary_category
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1625748955
                  ),
                })
              : _vm._e(),
            _vm.$store.getters.isPii
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("components.transaction_country"),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$store.getters.findOnlineCountryObj(
                                    scope.row.country_code
                                  ).label
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1940982317
                  ),
                })
              : _vm._e(),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("merchantAccount.beneficiary_name"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("cryptoJSAesDecrypt")(scope.row.account_name)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "min-width": "110",
                label: _vm.$t("merchantAccount.receiving_channel"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_c("span", [_vm._v(_vm._s(scope.row.code))])]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "min-width": "110",
                label: _vm.$t("merchantAccount.beneficiary_account_no"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("cryptoJSAesDecrypt")(scope.row.account_no)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm.$store.getters.curCountry.country_code === "AE"
              ? _c("el-table-column", {
                  attrs: {
                    "min-width": "140",
                    label: _vm.$t("map.benefit_address"),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.beneficiary_address)),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3832923948
                  ),
                })
              : _vm._e(),
            _c("el-table-column", {
              attrs: { label: _vm.$t("components.amount"), align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("toThousandFilter")(scope.row.amount))
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("merchantAccount.transaction_status"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          staticClass: "tag-custom",
                          attrs: {
                            type: _vm.getPOTransactionStatusType(
                              scope.row.transaction_status
                            ),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getPOTransactionStatusMap(
                                  scope.row.transaction_status
                                )
                              )
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("merchantAccount.create_time"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(scope.row.transaction_create_time)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("merchantAccount.complete_time"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(scope.row.transaction_return_time)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: _vm.$t("components.operation"), align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.transaction_id
                        ? _c(
                            "el-tooltip",
                            { attrs: { placement: "top" } },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("components.detail"))
                                    ),
                                  ]),
                                ]
                              ),
                              _c("svg-icon", {
                                attrs: {
                                  "class-name": "icon-function",
                                  "icon-class": "operation-detail",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onClickDetailTxt(scope.row)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            !_vm.listLoading
              ? _c("paginator", {
                  attrs: { "list-query": _vm.listQuery },
                  on: { "paginator-change": _vm.onClickPaginator },
                })
              : _vm._e(),
          ],
          1
        ),
        _c("StandardValuePaymentStepDetailsModal", {
          ref: "standardValuePaymentStepDetailsModal",
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }